var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapGetters } from "vuex";
import { Loading } from 'element-ui';
import { copy } from '../../helper/clipboard';
import Uploader from "../../common/components/uploader.vue";
import ShoppingManageService from '../../api/ShoppingManageService';
function formateHourMinute(num) {
    return (num + '').length == 2 ? (num + '') + ':00' : ('0' + num) + ':00';
}
function formateNumber(str) {
    return str ? str.slice(0, 2) - 0 : str;
}
var ConfigDetail = (function (_super) {
    __extends(ConfigDetail, _super);
    function ConfigDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageHeight = 400;
        _this.clipboardCopy = copy;
        _this.showProductdate = false;
        _this.isOpenAutoSign = true;
        _this.showIsOpenAutoSign = true;
        _this.isRefundConfirm = false;
        _this.collapseState = {
            basicConfig: true,
            orderLimit: true,
            afterSales: true,
            signSetting: true,
            otherSetting: true,
            customerService: true
        };
        _this.autoPublishMallGoods = false;
        _this.isShowNoPriceGoods = true;
        _this.formData = {
            is_open_shop: 0,
            shop_name: '',
            contact_phone: '',
            shop_website: '',
            shop_logo: '',
            is_open_register: 0,
            is_only_show_distribution_goods: 0,
            delivery_time: [],
            is_temp_business_order: 0,
            is_not_stock_order: 1,
            return_in_day: 0,
            auto_sign_day: 0,
            shop_logo_list: [],
            wechat_qrcode_list: [],
            wechat_account: null,
            is_show_delivery_amount: 1,
            is_show_price_not_login: 1,
            is_show_stock_quantity: 2,
            is_diff_sign: 1,
            is_open_enter_white_list: 1,
            is_open_min_order_money: 2,
            min_order_money: undefined,
            is_open_min_order_amount: 2,
            is_allow_append_goods: 1,
            min_order_amount: undefined,
            is_charge_shipping_by_day: 0,
            shopping_list_rule_stock: 0,
            shopping_list_rule: 1,
            shopping_auto_publish: 1,
        };
        _this.openSwitch = true;
        _this.checkboxGroup = [];
        _this.dataOptions = [
            {
                label: '周一',
                id: '1'
            },
            {
                label: '周二',
                id: '2'
            },
            {
                label: '周三',
                id: '3'
            },
            {
                label: '周四',
                id: '4'
            },
            {
                label: '周五',
                id: '5'
            },
            {
                label: '周六',
                id: '6'
            },
            {
                label: '周天',
                id: '0'
            }
        ];
        _this.expireTimeUnitMap = [
            {
                name: "分钟",
                value: 1
            },
            {
                name: "小时",
                value: 2
            },
            {
                name: "天",
                value: 3
            },
        ];
        return _this;
    }
    ConfigDetail.prototype.onIsOpenAutoSignChange = function (val, oldVal) {
        this.showIsOpenAutoSign = val;
    };
    ConfigDetail.prototype.created = function () {
        var _this = this;
        this.service = ShoppingManageService.getInstance();
        setTimeout(function () {
            _this.pageHeight = document.documentElement.clientHeight - 224;
        }, 300);
    };
    ConfigDetail.prototype.mounted = function () {
        this.getDetail();
    };
    ConfigDetail.prototype.changeWeek = function (val) {
        console.log(val);
    };
    ConfigDetail.prototype.toggleCollapse = function (key) {
        this.collapseState[key] = !this.collapseState[key];
    };
    ConfigDetail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.configShow({}).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.checkboxGroup = data.delivery_time[0] && data.delivery_time[0].day_week ? data.delivery_time[0].day_week.split(',') : ['0', '1', '2', '3', '4', '5', '6'];
            data.shop_logo_list = data.shop_logo ? [
                {
                    url: data.shop_logo
                }
            ] : [];
            data.delivery_time = data.delivery_time.map(function (v) {
                return {
                    start: formateHourMinute(v.start),
                    end: formateHourMinute(v.end),
                };
            });
            data.wechat_qrcode_list = data.wechat_qrcode ? [
                {
                    url: data.wechat_qrcode
                }
            ] : [];
            data.is_open_delivery_time == 1 ? _this.openSwitch = true : _this.openSwitch = false;
            data.is_show_goods_production_date == 1 ? _this.showProductdate = true : _this.showProductdate = false;
            if (data.is_open_auto_sign == 1) {
                _this.isOpenAutoSign = true;
                _this.showIsOpenAutoSign = true;
            }
            else {
                _this.isOpenAutoSign = false;
                _this.showIsOpenAutoSign = false;
            }
            data.is_refund_confirm == 1 ? _this.isRefundConfirm = true : _this.isRefundConfirm = false;
            data.shopping_auto_publish = data.shopping_auto_publish ? 1 : 0;
            _this.formData = data;
            _this.$emit('set-shopping-detail', data);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    ConfigDetail.prototype.addDeliveryTime = function (item, index) {
        this.formData.delivery_time = this.formData.delivery_time.concat({
            start: '',
            end: ''
        });
    };
    ConfigDetail.prototype.removeDeliveryTime = function (item, index) {
        this.formData.delivery_time = this.formData.delivery_time.filter(function (v, vIndex) { return vIndex != index; });
    };
    ConfigDetail.prototype.checkSave = function () {
        if (this.errors.items.length) {
            this.$message.warning(this.errors.items[0].msg);
            return false;
        }
        var timeFlag = true;
        this.formData.delivery_time.forEach(function (v) {
            if (!v.start || !v.end) {
                timeFlag = false;
            }
        });
        if (!timeFlag && this.openSwitch) {
            this.$message.warning('送货时段不能设置为空');
            return false;
        }
        return true;
    };
    ConfigDetail.prototype.save = function () {
        var _this = this;
        if (!this.checkSave()) {
            return;
        }
        var formData = this.formData;
        var params = {
            is_open_enter_white_list: formData.is_open_enter_white_list,
            is_open_shop: formData.is_open_shop,
            shop_name: formData.shop_name,
            contact_phone: formData.contact_phone,
            shop_website: formData.shop_website,
            shop_logo: formData.shop_logo_list.length > 0 ? formData.shop_logo_list[0].url : '',
            is_open_register: formData.is_open_register,
            is_only_show_distribution_goods: formData.is_only_show_distribution_goods,
            is_show_delivery_amount: formData.is_show_delivery_amount,
            is_show_price_not_login: formData.is_show_price_not_login,
            is_show_stock_quantity: formData.is_show_stock_quantity,
            payment_voucher_audit_node: formData.payment_voucher_audit_node,
            delivery_time: JSON.stringify(formData.delivery_time.map(function (v) {
                return {
                    start: formateNumber(v.start),
                    end: formateNumber(v.end),
                    day_week: _this.checkboxGroup.join(',')
                };
            })),
            is_temp_business_order: formData.is_temp_business_order,
            is_not_stock_order: formData.is_not_stock_order,
            return_in_day: formData.return_in_day,
            auto_sign_day: formData.auto_sign_day,
            wechat_qrcode: formData.wechat_qrcode_list.length > 0 ? formData.wechat_qrcode_list[0].url : '',
            wechat_account: formData.wechat_account,
            is_open_delivery_time: this.openSwitch == true ? 1 : 2,
            is_diff_sign: formData.is_diff_sign,
            is_show_goods_production_date: this.showProductdate ? 1 : 2,
            is_open_auto_sign: this.isOpenAutoSign ? 1 : 0,
            is_refund_confirm: this.isRefundConfirm ? 1 : 0,
            is_open_min_order_money: formData.is_open_min_order_money,
            min_order_money: formData.min_order_money,
            is_open_min_order_amount: formData.is_open_min_order_amount,
            min_order_amount: formData.min_order_amount,
            is_charge_shipping_by_day: formData.is_charge_shipping_by_day,
            shopping_list_rule_stock: formData.shopping_list_rule_stock,
            shopping_list_rule: formData.shopping_list_rule,
            shopping_auto_publish: formData.shopping_auto_publish,
            expire_time: formData.expire_time,
            expire_time_unit: formData.expire_time_unit,
            is_allow_append_goods: formData.is_allow_append_goods
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.configSave(params).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            _this.getDetail();
            window._czc.push(["_trackEvent", '店铺基本设置保存', '店铺基本设置保存']);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    __decorate([
        Watch('isOpenAutoSign')
    ], ConfigDetail.prototype, "onIsOpenAutoSignChange", null);
    ConfigDetail = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            components: {
                Uploader: Uploader
            }
        })
    ], ConfigDetail);
    return ConfigDetail;
}(Vue));
export default ConfigDetail;
